<template>
    <div class="container">
        <div class="title ">
            <div style="position: relative">
                <div class="firstitle">
                    <img src="../../assets/images/discovery/home/icon_find.png" alt="">
                </div>
                <div class="name">发现</div>
            </div>
            <div class="rightCon" v-if="isShow2">
                <div style="position: absolute;left: -16px;top: -1px">
                    <img src="../../assets/images/discovery/home/icon_favarite.png" alt="">
                </div>
                <div style="margin-right: 30px">&nbsp;收藏夹</div>
                <div style="position: absolute;top: -1px ;right: 18px">
                    <img src="../../assets/images/discovery/home/icon_right.png" alt="" width="10" height="10">
                </div>
            </div>
        </div>
        <div class="fond">
            <span style="font-size: 16px">正在进行</span>
        </div>
        <van-swipe
                :loop="false"
                :show-indicators="false"
                :width="200"
                :height="110">
            <van-swipe-item v-for="(item,index) in titlesNews" :key="index">
                <div class="swipeStyle" @click="openTabNews(item.url)">
                    <img :src=" item.imgUrl + '?x-oss-process=image/quality,q_60/resize,w_356'" alt="" style="width: 100%;height: 100%">
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="swipeStyle" @click="openTabNews('https://mp.weixin.qq.com/s/wfpeV5rkRpCMdHUI3AKkbA')">
                    <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab6_2_sm.jpg?x-oss-process=image/quality,q_60/resize,w_356" alt="" style="width: 100%;height: 100%">
                </div>
            </van-swipe-item>
        </van-swipe>
        <div class="huadong">
            <div class="bt">
                <nav>
          <span class="navSpan" @touchstart="qh(index)"
                v-for="(item,index) in tabTitles"
                :key="index"
                :class="{active:show==index+1}">
            {{item}}
            <br>
            <span :class="{active2:show==index+1}"
                  style="border-radius: 5px;display: inline-block;height: 3px;width: 30%"></span>
          </span>
                </nav>
            </div>
            <div>
                <div v-show="index == 0" title="政府动态">
                    <div
                            class="list"
                            v-for="(item,index) in tabs1"
                            :key="index"
                            @click="openTabNews(item.url)">
                        <div class="item">
                            <img :src="item.imgUrl + '?x-oss-process=image/quality,q_60/resize,w_670'">
                            <div class="con">
                                <h3>{{item.title}}</h3>
                                <p class="liusanhang">
                                    {{item.content}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/eipse4qgefzF3jal8iAeTA')">
                        <div
                                class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab1/new1.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>李学忠率省人大调研组在宁波调研，搭把手智慧一体化回收体系获好评</h3>
                                <p class="liusanhang">
                                    4月10日，省人大常委会副主任李学忠，省人大常委会委员、环资委副主任委员徐纪平，省人大常委会环资工委副主任戴均玺，省建设厅副厅长张奕等率省人大常委会调研组，在甬调研垃圾分类处置工作情况。市人大常委会副主任李谦，市人民政府副市长沈敏，市人大常委会城建环资工委主任俞进，市政府副秘书长、市综合执法局局长郑一平等参加。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/g3mZVA8K32TYsILDlaQrZQ')">
                        <div
                                class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab1-pic1.png?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>凌晨空荡荡的马路上，他们成了最忙碌的逆行者</h3>
                                <p class="liusanhang">
                                    有一群人，他们平凡却如此不一样...疫情之下，前进与后退中，他们义无反顾的选择了前进。他们就是搭把手抗击疫情支援三江购物配送保障民生供应的最美逆行者！
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/ughKMDnsFdt54WKdqkWrTw')">
                        <div
                                class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab1-pic2.png?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>携手战疫，鲜蔬直达！无接触式配送，搭把手来做您的守＂胃＂者</h3>
                                <p class="liusanhang">
                                    疫情汹汹，牵动人心。为了解决甬城市民的吃菜难题，让大家安全在家也能吃上新鲜果蔬肉类，补充营养，搭把手联合宁波市供销社，开通线上“菜篮子”配送服务，顺丰将全力保障食材的配送。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/rwJnRazDogkVV_HRNOdleQ')">
                        <div
                                class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab-11.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>战“疫”路上“搭把手”，支援配送保民生！
                                </h3>
                                <p class="liusanhang">
                                    2月5日上午11点至12点，宁波市副市长李关定及市保供领导小组携市内各商超企业代表在三江总部四楼召开座谈会议，会议就疫情期间如何确保宁波市民一日三餐问题展开积极讨论。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/h3FlJK9oS962vphN1_M_QQ')">
                        <div
                                class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab1-pic3.png?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>宁波供销智慧产业园揭幕仪式隆重举行</h3>
                                <p class="liusanhang">
                                    新春将至，喜事连连。1月19日上午，宁波供销智慧产业园揭幕仪式隆重举行，宁波市供销合作社联合社党委书记、理事会主任、宁波供销集团公司董事长李斌携社领导班子一行；宁波市鄞州区姜山镇党委书记、宁波市鄞州工业园区管委会党工委书记徐卫成、鄞州区姜山镇副镇长詹祥以及宁波供销再生资源科技有限公司董事长郎文琴、总经理王鲸航，CEO闵亚军、供销电商总经理汪勇等领导一同揭幕。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/AXblMDltW9rbyoCCpIUvIQ')">
                        <div
                                class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab1-pic4.png?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>甬商携26个项目310亿资金回家，搭把手回收参加项目签约仪式</h3>
                                <p class="liusanhang">
                                    为推进发展宁波生活垃圾处理水平，宁波供销再生资源科技有限公司与陶朗分选技术（厦门）有限公司双方拟就生活垃圾可回收物精确智能化分拣，签订了挪威陶朗（中国）宁波合作项目。1月7日下午，宁波供销再生资源科技有限公司总经理王鲸航出席了甬商回归项目签约仪式。                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/NW1OlJlg992ogEo69cMvGw')">
                        <div
                                class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20200120101028.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>投垃圾去日本 | 最美小镇我想去，免费考察行
                                </h3>
                                <p class="liusanhang">
                                    投垃圾去日本 | 最美小镇我想去，免费考察行</p>
                            </div>
                        </div>
                    </div>

                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/QKUvlJB0tIY2Z05h4vztxA')">
                        <div
                                class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab1-6.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>宁波市垃圾分类全民行动日 | 一起分，更美好
                                </h3>
                                <p class="liusanhang">
                                    12月21日 宁波市垃圾分类全民行动日 | 一起分，更美好</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/KPkBhu08jb7tq29NaxCGRA')">
                        <div
                                class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab1_1.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>喜讯 | 搭把手回收获2019年度中国智能+垃圾分类年度典型案例一等奖</h3>
                                <p class="liusanhang">
                                    2019年11月25-27日，由中国城市环境卫生协会主办，智慧环卫专委会组织承办的2019中国智慧环卫高峰论坛在广西柳州召开。来自政府主管部门的领导、业界领袖、知名专家学者及环卫产业界人士300余人出席了本次高峰论坛。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/9CCUGkvOkNHeN-IORL4J8A')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab1_2.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>沈敏副市长调研高新区垃圾分类工作 点赞“搭把手”智能化分类体系</h3>
                                <p class="liusanhang">
                                    2019年11月8日，浙江省宁波市副市长沈敏一行调研高新区垃圾分类工作。上午9时左右，在宁波市高新区管委会副主任张立平等领导陪同下，沈敏副市长一行来到高新区交通紫园小区，就社区垃圾分类工作开展情况把脉问诊。作为“搭把手”垃圾分类智能化前端管理全体系试点小区，交通紫园小区推进分类智能化管理的措施已经成为社区垃圾分类的亮点之一。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/9kd8qxwDm2p-Canu62VwZQ')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab1_3.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>世行称赞“搭把手”智能化分类体系</h3>
                                <p class="liusanhang">近日，世行垃圾分类项目经理 Frank 等一行四人对宁波市城镇生活废弃物收集循环利用示范项目的实施情况开展为期3天的2019年下半年检查工作。
                                    2019年11月22日上午，世行办一行实地考察高新区可回收物收集体系试点项目。在市发改委、市财政局、市分类办单位等领导陪同下，调研团一行来到高新区交通紫园小区。
                                    作为“搭把手”垃圾分类智能化前端管理全体系试点小区，在小区调研期间，宁波供销再生资源科技有限公司CEO闵亚军全程陪同，并向考察领导一行就体系运行情况做了详细汇报。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/LV6MG00qgyqfsNzGlPYn4g')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab1_4.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>搭把手回收亮相2019年世界数字经济大会，助力智能垃圾分类美好未来</h3>
                                <p class="liusanhang">
                                    2019年9月6日—8日，为期3天的2019年世界数字经济大会暨第九届中国智慧城市与智能经济博览会（以下简称“智博会”）在宁波国际会展中心拉开帷幕。本届智博会的展览展示重点聚焦新型智慧城市和数字经济、智能制造的发展主题，广泛邀请国内外知名企业来参展，集中展示全球领先、前沿的数字经济、人工智能、5G、大数据、云计算、区块链等的一批新技术、新产品、新应用；同时系统全面展示浙江省及宁波市在数字经济发展中的实践经验和取得的成效。
                                    本次大会，展览总面积近3万平米，较历年进一步扩大，设数字经济馆、智能制造馆、智慧应用馆、新一代信息技术馆和智能产品馆等5大主题馆。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="index == 1" title="搭把手活动">
                    <div
                            class="list"
                            v-for="(item,index) in tabs2"
                            :key="index"
                            @click="openTabNews(item.url)">
                        <div class="item">
                            <img :src="item.imgUrl + '?x-oss-process=image/quality,q_60/resize,w_670'">
                            <div class="con">
                                <h3>{{item.title}}</h3>
                                <p class="liusanhang">
                                    {{item.content}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/NW1OlJlg992ogEo69cMvGw')">
                        <div class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2-pic1.png?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>投垃圾去日本 | 最美小镇我想去，免费考察行</h3>
                                <p class="liusanhang">
                                    这一次，搭把手回收发起【日本考察官】体验计划，希望通过全新视角下的垃圾分类生活为城市居民带来一点启示。
                                    通过票选出的日本之行考察官，我们将送你一场不要钱的旅行。别问都有谁，可能有你就对了！
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/LTV3O-DSyI6pgYJAfwmdtA')">
                        <div
                                class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2-pic2.png?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>市民组团参加回收体验 了解收运分拣全流程</h3>
                                <p class="liusanhang">
                                    参尽管下着淅淅沥沥的小雨，但参加“搭把手回收体验”活动的市民热情不减，早早的等在了集合点。参加活动的市民拿着从自己家带来的报纸、塑料瓶、旧衣物等可回收物，在现场体验智能回收机的使用，针对第一次使用的市民，宁波三套讲大道生活栏目主持人王阿姨和青青还在现场讲解如何使用。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/oEDxPRrtt6LFMCxpHAp7YA')">
                        <div
                                class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2-pic3.png?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>全民行动日 | 分类回收十佳奖品大派送啦！</h3>
                                <p class="liusanhang">
                                    搭把手回收在12月21日当天开展了“全民参与垃圾分类，投递获双倍积分”活动。市民通过搭把手智能回收设备参与垃圾分类投递，即可获得双倍资源币收益，吸引了不少市民们的参与。接下来，搭把手回收的礼物派送员将陆续把奖品送出，所在上榜社区（学校）的朋友们，等着我们呐！
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/GaHbnC6EORVH8pjQCl7tTA')">
                        <div
                                class="item">
                            <img src="../../assets/images/discovery/newsTab1/tab1-5.jpg">
                            <div class="con">
                                <h3>空瓶能换地铁票！这个周末，来鼓楼站寻找搭把手吧！</h3>
                                <p class="liusanhang">
                                    为响应宁波市生活垃圾分类全民行动日的号召，搭把手回收作为宁波再生资源企业的榜样之一，积极参与策划组织了一系列的活动。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/VP2dAnOGlWvzmZhBxKyssw')">
                        <div
                                class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2_5.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>全民行动日 | 搭把手回收投递前十榜单</h3>
                                <p class="liusanhang">
                                    12月21日，是宁波市第一个全民行动日，市分类办策划了盛大的主题宣传活动，活动设主会场1处，各区（县）市、园区分会场12处，以及全市495个社区681个小区也将在当日上午同步开展丰富多彩的垃圾分类主题活动。                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/LxWZ31lYOmau5Zgo2ZZbgw')">
                        <div
                                class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2-6.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>助力全民垃圾分类，宁波市体育彩票管理中心携手搭把手回收送彩票！</h3>
                                <p class="liusanhang">
                                    2016年12月21日中央财经领导小组第十四次会议，习近平总书记提出普遍推行垃圾分类制度的号召。为更好贯彻落实习近平总书记环境建设的指导思想，宁波市也加快了生活垃圾分类工作的步伐。近年来，宁波市垃圾分类全民知晓率、参与度和准确度提升明显，垃圾分类全民行动日的打造众望所归。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/F165-55qdcvOv6RYOzI-VQ')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/icon6-5.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>12月20日
                                    分类考试在线答，全民参与分红包
                                </h3>
                                <p class="liusanhang">分类考试在线答，全民参与分红包</p>
                            </div>
                        </div>
                    </div>

                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/3c1YrTz26OE5NQ13o5FNIg')">
                        <div
                                class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2-7.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>参与垃圾分类投递，双倍资源币收益</h3>
                                <p class="liusanhang">
                                    参与垃圾分类投递，双倍资源币收益                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/P_8Gr1SZH9vKc1b31R9tyw')">
                        <div
                                class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2_8.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>搭把手联合1001PlayFM，邀您共同参与垃圾分类！</h3>
                                <p class="liusanhang">
                                    有这样一首歌：
                                    没有人没听过，没有人没唱过，
                                    没有人没为它哭过。
                                    这首歌叫做《明天会更好》。                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/2bheK_aVxIlaM0dEHrOUDw')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2_3.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>搭把手摆摊有young生活市集，倡导垃圾分类</h3>
                                <p class="liusanhang">10.18-20
                                    印象城 x 网易联手
                                    打造“各有态度生活节”
                                    网易音乐展、有young生活趴...
                                    燃炸young生活
                                    共同进行一场各有态度的生活狂欢！
                                    搭把手回收携智能饮料瓶回收机
                                    周边原创物品、手工纸箱玩具等
                                    亮相“有young生活市集”
                                    艺术环保，倡导垃圾分类</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/II1RUfvLyNqVkcwz_Zijzw')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2_4.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>搭把手 x AND NOW 森林瑜伽绿色分类新生活</h3>
                                <p class="liusanhang">10月11日，AND NOW 两周年庆活动
                                    携手搭把手一起
                                    倡导绿色生活
                                    与自然共呼吸</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-show="index == 2" title="搭把手课堂">
                    <div
                            class="list"
                            v-for="(item,index) in tabs3"
                            :key="index"
                            @click="openTabNews(item.url)">
                        <div class="item">
                            <img :src="item.imgUrl + '?x-oss-process=image/quality,q_60/resize,w_670'">
                            <div class="con">
                                <h3>{{item.title}}</h3>
                                <p class="liusanhang">
                                    {{item.content}}
                                </p>
                            </div>
                        </div>
                    </div>


                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/CGGKBli40oRrQdYIDtxEtQ')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab4_1.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>11月29日 搭把手课堂 | 走进浙江大学宁波理工学院垃圾分类专题活动！
                                </h3>
                                <p class="liusanhang">
                                    搭把手回收进宁波高校推广宣传垃圾分类的工作越来越火热。11月29日，搭把手回收联合浙江大学宁波理工学院信息科学与工程学院，给学院的师生朋友们带去了一场别开生面的专题讲座。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/D3WWscvvVm5RfyL3sY-_KA')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab4-5.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>11月14日 搭把手课堂 | 华泰小学研学活动，小手搭搭，绿色大家
                                </h3>
                                <p class="liusanhang">11月13日，鄞州区华泰小学联合搭把手回收“小手搭搭，绿色大家”活动，学校四年级年段开展了为期一天的环保研学活动。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/a-rm7AbZEDQ6ZRZRpjDnLg')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab4_3.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>10月24日 搭把手课堂 | 宁波诺丁汉大学垃圾分类校园宣传活动
                                </h3>
                                <p class="liusanhang">最近，搭把手回收进宁波高校推广宣传垃圾分类的工作依旧火热。
                                    10月19日、20日、23日，搭把手回收联合宁波诺丁汉大学诺丁绿环保社，举办了“垃圾分类，宁波更美”的进校园活动。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/i7NMQpt8Q3f57j0Tiue5dg')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab4_4.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>10月17日 搭把手课堂 | 宁波理工学院垃圾有价值，分类进行时
                                </h3>
                                <p class="liusanhang">随着宁波正式施行生活垃圾强制分类，搭把手回收的垃圾分类推广宣传工作依旧没有停下步伐，除了社区，也在不断走进宁波的高校。
                                    10月16日，搭把手回收联合浙江大学宁波理工学院生物与化学工程学院，举办了一场“垃圾有价值，分类进行时”的校园活动。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="index == 3" title="搭把手资讯">
                    <div
                            class="list"
                            v-for="(item,index) in tabs4"
                            :key="index"
                            @click="openTabNews(item.url)">
                        <div class="item">
                            <img :src="item.imgUrl + '?x-oss-process=image/quality,q_60/resize,w_670'">
                            <div class="con">
                                <h3>{{item.title}}</h3>
                                <p class="liusanhang">
                                    {{item.content}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/AuSz1IAWTD5aqWNr4HoI3g')">
                        <div
                                class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab4-pic1.png?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>搭把手用户量突破40万，携手抗疫众志成城</h3>
                                <p class="liusanhang">
                                    还记得上次搭把手注册会员突破30万的时候，这一次，我们又迈向了一个新台阶迎来了40万会员量！
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/-vExn4N5untJhZaqeJJF8g')">
                        <div
                                class="item">
                            <img src="http://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab4-pic2.png?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>2020，垃圾分类有这些“小目标”</h3>
                                <p class="liusanhang">
                                    2020 来啦！回顾 2019 年，这一年你新增了哪些记忆呢？“垃圾分类”无疑是这一年中国人共同的一个热点记忆。2020年垃圾分类，我们有这些“小目标”~
                                </p>
                            </div>
                        </div>
                    </div>


                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/BV7ObINNAwJeQ-mwczcr2g')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab3-5.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>12月10日 搭把手今日头条，可回收物“红黑榜”</h3>
                                <p class="liusanhang">
                                    这是搭把手投递“红黑榜”首次曝光
                                    目的是为了鼓励大家
                                    更好更准确的投售
                                    话不多说，开榜battle！
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/wfpeV5rkRpCMdHUI3AKkbA')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab6_2.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>不要再乱喂啦！点击就看正确的投递指南
                                </h3>
                                <p class="liusanhang">
                                    大家好
                                    我是人见人爱
                                    能用可回收物换资源币的
                                    搭把手智能回收机
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/wCbtksqjZNZC0k8EILeR-g')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab6_1.jpg?x-oss-process=image/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>手机扫码领垃圾袋，“码”上能溯源，宁波这个小区用上了
                                </h3>
                                <p class="liusanhang">
                                    在高新区的紫园小区内，搭把手回收的厨余&其他垃圾智能前端管理设备，一进小区门就能看见了。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/fRU56lbfb5RVTfvWwUf1NA')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab5_2.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>9月30日 宁波垃圾分类学院成立啦！
                                </h3>
                                <p class="liusanhang">
                                    9月29日，在《宁波市生活垃圾分类管理条例》正式实施前夕，由宁波市综合行政执法局与宁波广播电视大学合作共建的宁波垃圾分类学院落户宁波广播电视大学。这是政府职能部门与高校联手打造的一个集垃圾分类教育培训、宣传策划、理论研究等于一体，线上线下相结合的综合性平台，学院将采用访学、研学、讲师团下基层宣讲等多种形式，给不同群体提供多层次、多方位、多样化的教育培训服务。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/LvJsQ5LewJXMHvNOhkGZRg')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2_1.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>拉脱维亚设计师楚希吉参观搭把手</h3>
                                <p class="liusanhang">楚希吉，是一位来自拉脱维亚的设计师。
                                    她酷爱旅行，
                                    当她为了工作或娱乐旅行时，
                                    总是带着时尚杂志或报纸回家，
                                    这些杂志或报纸会提醒她旅途中的经历和冒险。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/Gp9ZAV_SscHBT4NhG6z9Ww')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab2_2.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>搭把手回收北仑大榭两地员工联合消防演习</h3>
                                <p class="liusanhang">
                                    2019年10月22日上午9点半，北仑大榭两地员工联合消防演习在搭把手回收北仑区再生资源分拣中心举行。参与员工有各区域负责人、工作人员和清运司机共27名，分别来自北仑分拣中心、大榭分拣中心以及所处各区域各暂存点</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="index == 4" title="分类知识">


                    <div
                            class="list"
                            v-for="(item,index) in tabs5"
                            :key="index"
                            @click="openTabNews(item.url)">
                        <div class="item">
                            <img :src="item.imgUrl + '?x-oss-process=image/quality,q_60/resize,w_670'">
                            <div class="con">
                                <h3>{{item.title}}</h3>
                                <p class="liusanhang">
                                    {{item.content}}
                                </p>
                            </div>
                        </div>
                    </div>





                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/w0ly4YttY6kTS4Jiyk_pnQ')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab3_1.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>11月6日 纳入年度考核！12月31日起浙江将限制一次性消费品</h3>
                                <p class="liusanhang">
                                    随着经济的快速发展和人民生活水平的不断提高，浙江住宿、餐饮等服务性单位一次性消费用品的消耗量持续增长，既浪费资源，又污染环境。
                                    10月31日，浙江省生活垃圾分类工作领导小组办公室、省住房和城乡建设厅等十部门联合发布通知，在浙江全省限制一次性消费用品。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/gvESd-fP1ZLAlv_2Rg68tw')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab3_2.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>11月4日 四部门印发通知：学校不得强制学生使用塑料书皮
                                </h3>
                                <p class="liusanhang">
                                    还记得学生时代的你用什么包书皮的吗？对于，现在的中小学生，书皮可能就一种——塑料书皮。近日，教育部办公厅、生态环境部办公厅、市场监管总局办公厅、中国科协办公厅四个部门共同印发“关于在中小学落实生态文明思想、增强生态环境意识”的通知。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/1vhs4ylspIVnGysCKpSVNQ')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab3_3.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>11月1日 一个月劝导3万余次！拒不履行垃圾分类义务，宁波这样罚！
                                </h3>
                                <p class="liusanhang">
                                    今天，宁波市综合行政执法局通报了《宁波市生活垃圾分类管理条例》实施一个月以来的情况。截至10月底，中心城区生活垃圾分类基本覆盖，奉化区及各县（市）达90%。整体工作在今年一、二、三季度全国46个重点城市考核中均排名第三。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/Cvwl-r-PN5qwsTS9r9AjCA')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab5_1.png?x-oss-process=image/format,jpg/quality,q_60/resize,w_670">
                            <div class="con">
                                <h3>10月8日 阅兵红毯竟是由40多万个废旧矿泉水瓶制成的！
                                </h3>
                                <p class="liusanhang">10月1日的阅兵仪式
                                    不知道大家都看了吗
                                    是否也和我一样十分激动自豪...
                                    你们知道吗？
                                    这次阅兵式上所用的2.4万平方米的红毯
                                    是由40多万个废旧矿泉水瓶制成的！</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/2ZPpMm1P6CByAPRflfgcGQ')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab5_3.png?x-oss-process=image/quality,q_60/resize,w_670/format,jpg">
                            <div class="con">
                                <h3>8月28日 过期药物危害多，垃圾分类有讲究！
                                </h3>
                                <p class="liusanhang">几乎每个家庭都会存些常用药，以备不时之需。很多时候不少药都过了期，感冒药、口服液、保健品……存了满满一盒还放在家里。
                                    据药监部门统计，我国一年产生过期药品约1.5万吨，如用载重5 吨的大卡车来运，至少需要3000 辆。而仅仅是1颗过期药对环境的污染就相当于3节废旧电池的污染。</p>
                            </div>
                        </div>
                    </div>
                    <div class="list" @click="openTabNews('https://mp.weixin.qq.com/s/xE4WCXPuSFpmCPNztL7PlQ')">
                        <div class="item">
                            <img src="https://dbshs.oss-cn-shanghai.aliyuncs.com/active/insert_app_discovery/tab5_4.png?x-oss-process=image/quality,q_60/resize,w_670/format,jpg">
                            <div class="con">
                                <h3>8月7日 快收藏！宁波生活垃圾分类投放指南3.0版来了！
                                </h3>
                                <p class="liusanhang">
                                    历经3次征求意见、多轮修改，今天，《宁波市生活垃圾分类投放指南》（后简称《投放指南》）终于在宁波市生活垃圾分类工作推进会上正式公布。宁波市生活垃圾分类终于迎来了“标准答案”！</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Tab, Tabs} from 'vant';
    import {Swipe, SwipeItem} from 'vant';

    export default {
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem
        },
        data() {
            return {
                active: 0,
                tabTitles: ['政府动态', '搭把手活动', '搭把手课堂','搭把手资讯',  '分类知识'],
                discoveryList: [1, 2],
                isShow2: false,
                index: 0,
                show: 1,
                titlesNews: [
                    // {
                    //     url: '',
                    //     imgUrl:''
                    // },

                    // {
                    //     url: 'https://mp.weixin.qq.com/s/2I8Y7QRbXY8ZxFQcHhksYQ',
                    //     imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/top1.jpg'
                    // },
                    // {
                    //     url: 'https://mp.weixin.qq.com/s/uPCZvSdZB60CcojH5ExY2A',
                    //     imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/top2.png'
                    // },
                    // {
                    //     url: 'https://mp.weixin.qq.com/s/fnw6L49bQsCiTkxQ3L0ViA',
                    //     imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/top3.png'
                    // },

                    // {
                    //     url: 'https://mp.weixin.qq.com/s/I5YEdXqDdX4FdbkCzcxyMg',
                    //     imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/news1.jpg'
                    // },
                    {
                        url: 'https://mp.weixin.qq.com/s/Fwgy_cAoxqgdDEWi_zxU0Q',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/news2.jpg'
                    },
                    {
                        url: 'https://mp.weixin.qq.com/s/BP4yYNXNcczRP16Y4yXICw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/news3.jpg'
                    },
                    {
                        url:'https://mp.weixin.qq.com/s/Hlh2Bb82wvtpUjlJDw54jQ',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/news5.jpg'
                    },
                    {
                        url:'https://mp.weixin.qq.com/s/UziE5L0Igu44fKl4HqPXcw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/top4.png'
                    },

                ],
                tabs1: [
                    // {
                    //     title:'',
                    //     url:'',
                    //     imgUrl:'',
                    //     content:''
                    // },
                    {
                        title:'宁波市第二个垃圾分类全民行动日正式启动',
                        url:'https://mp.weixin.qq.com/s/BP4yYNXNcczRP16Y4yXICw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/tab1_3.jpg',
                        content:'12月21日上午，宁波市第二个生活垃圾分类全民行动日主会场在五一广场剧场成功举办，出席本次活动的领导有市委常委、宣传部长李军，市人大副主任王建社，市政协副主席叶剑鸣，市政府副秘书长、市分类办主任、市综合行政执法（城市管理）局党组书记、局长郑一平，参加活动的还有我市垃圾分类领导小组51家成员单位的分管领导、区（县）市城管局主要领导，以及获奖人员和演职人员共计200余人。'
                    },
                    {
                        title:'世行贷款二期项目鉴别团来宁波考察，垃圾分类迎来新发展机遇',
                        url:'https://mp.weixin.qq.com/s/q4oZug6zwh-T_QSJt3TJhA',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/tab1_1.jpg',
                        content:'10月27日至30日，世界银行中国、蒙古和韩国局局长马丁·芮泽一行12人来到宁波市，通过现场考察、座谈讨论的方式对世行贷款二期项目宁波城镇生活垃圾智慧分类、收集、循环利用示范项目进行考察鉴别。宁波市副市长沈敏会见了马丁·芮泽一行，市政府副秘书长、市综合行政执法局党组书记、局长郑一平陪同。'
                    },
                    {
                        title:'浙江省第二十四个环卫工人节庆祝大会在甬召开，搭把手获表彰',
                        url:'https://mp.weixin.qq.com/s/0VTCUhtIIaHLxiyxIYwhAg',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/tab1_2.jpg',
                        content:'10月26日上午，浙江省第二十四个环卫工人节庆祝表彰大会在宁波召开，来自全省环卫系统的200余位集体和个人代表出席表彰大会。本次，搭把手回收获此殊荣，是对智慧一体化分类体系建设所取得成绩的肯定，亦是对全体搭把手人努力付出的一份极大鼓舞。未来，搭把手将以此为激励，为宁波垃圾分类“功在当代、利在千秋”的民生工程贡献自己的一份力量。'
                    },

                    {
                        title:'广州市供销社小组来甬考察，“搭把手”智能化分类体系获好评',
                        url:'https://mp.weixin.qq.com/s/tgP0E6dUq09JaRphbVvCgA',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/tab1_1.jpg',
                        content:' 9月17日上午，广州市供销合作总社党组书记、主任吴尚伟率广州市供销合作社调研组一行，来甬考察调研“搭把手”智慧一体化回收体系建设工作。'
                    },
                    {
                        title:'陈仲朝常务副市长专题调研“搭把手”智慧一体化分类体系',
                        url:'https://mp.weixin.qq.com/s/k4rL00X7D7Fq8f2_udgqyg',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/tab1_2.jpg',
                        content:' 9月16日上午，宁波市委常委、常务副市长陈仲朝率市发改委、市财政局、市自然资源规划局、市生态环境局、市住建局、市商务局、市综合执法局等有关部门负责人，专题调研“搭把手”智慧一体化回收体系建设工作。'
                    },

                    {
                        title:'宋越舜副书记调研市供销社工作，充分肯定搭把手智慧一体化回收体系',
                        url:'https://mp.weixin.qq.com/s/zinDDwnSr2BpzRriHH2dxw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-07_30/tupian1.png',
                        content:'2020年6月23日上午，浙江省宁波市市委副书记宋越舜一行莅临鄞州区姜山再生资源分拣中心调研“搭把手”智慧一体化回收体系建设工作，宁波市市委副秘书长胡杰、鄞州区委副书记王邦进、姜山镇党委书记徐卫成等领导陪同，宁波市供销合作社联合社理事会主任李斌、宁波供销再生资源科技有限公司总经理王鲸航、CEO闵亚军接待。'
                    },
                    {
                        title:'市人大代表海曙中心小组调研“搭把手”智能化分类体系',
                        url:'https://mp.weixin.qq.com/s/37S4U-gYcCj93g_m75wbAw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-07_30/tupian2.jpg',
                        content:'为更高水平推进宁波市垃圾分类工作，促进垃圾减量化、资源化、无害化，助力宁波争创文明城市“六连冠”，6月23日，市人大代表海曙中心小组第一、三小组联组调研垃圾分类设施体系建设和低值可回收物回收利用工作，市供销社副主任戴建国、宁波市综合行政执法局（城市管理局）副巡视员王自强、市容环境管理处处长徐谟开全程陪同。'
                    },

                    {
                        title:'宁波市垃圾分类专项活动——我分类 我晒图',
                        url:'https://mp.weixin.qq.com/s/v1ZzGZP0p51Q5bFlSej7VA',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab1/dongtai1.png',
                        content:'从现在起，正确分类厨余垃圾，拍照上传就能抢红包啦！\n' +
                        '\n' +
                        '\n' +
                        '宁波市垃圾分类办推出新活动“我分类 我晒图”，2020年6月1日至12月31日，全民参与，天天领红包！\n'
                    },
                    {
                        title:'两会声音 | 总书记再提垃圾分类，代表委员们热议',
                        url:'https://mp.weixin.qq.com/s/LpOmI7e3TCT5JIs-s-bgXw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab1/dongtai2.png',
                        content:'5月24日，中共中央总书记、国家主席习近平参加十三届全国人大三次会议湖北代表团的审议时再次提到“垃圾分类”！'
                    }
                ],
                tabs2: [
                    // {
                    //     title:'',
                    //     url:'',
                    //     imgUrl:'',
                    //     content:''
                    // },


                    // {
                    //     title:'涨价啦！新年第一弹好消息，织物纸类回收价上调 ↑↑↑',
                    //     url:'https://mp.weixin.qq.com/s/I5YEdXqDdX4FdbkCzcxyMg',
                    //     imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/tab2_5.jpg',
                    //     content:'即日起，搭把手织物回收价格翻倍上涨啦！￥0.15/KG→→→￥0.3/KG是的，没有看错！直接翻两倍回收价哦！'
                    // },
                    {
                        title:'搭把手【年度账单】已发送，可口可乐给您送好礼啦~',
                        url:'https://mp.weixin.qq.com/s/Fwgy_cAoxqgdDEWi_zxU0Q',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/tab2_4.jpg',
                        content:'12月19日起，通过【搭把手回收】小程序，可以查看个人专属年度账单。各类可回收物，一年内的回收情况，一目了然。本年度被搭把手评选为TOP10投递的用户们，将获得由搭把手合作伙伴浙江太古可口可乐饮料有限公司总价值万元的精美奖品。'
                    },
                    // {
                    //     title:'12月21日 | 参与垃圾分类投递，双倍资源币收益',
                    //     url:'https://mp.weixin.qq.com/s/97fZ9l-yjrZRxU5iEkHI8g',
                    //     imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/tab2_3.jpg',
                    //     content:'通过搭把手智能回收设备，参与垃圾分类投递，当天首次投递完成，可获得双倍资源币收益。（上限12.21个资源币）'
                    // },
                    // {
                    //     title:'聪明的你还不快来！分类知识在线答，瓜分10万红包哦',
                    //     url:'https://mp.weixin.qq.com/s/mMKBaDsc5J-LXw-be6Tv1Q',
                    //     imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/tab2_2.jpg',
                    //     content:'通过【搭把手回收】小程序，参与垃圾分类知识答题，共10题，满分100分，≥60分即可获得随机资源币红包；活动期间，每位用户可领1次红包。'
                    // },
                    {
                        title:'天冷添衣啦！10月23-25日，宁波文化广场搭把手摊位旧衣换好礼！',
                        url:'https://mp.weixin.qq.com/s/k7jWgu0323LV9zn7FSE61g',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/tab2_1.png',
                        content:'活动期间市民可将家中旧衣物带到现场搭把手摊位（B28旁边）进行捐赠捐赠两件及以上衣物即可换取时尚消费嘉年华品牌优惠券一张（捐赠须知：长袖长裤外套等秋冬装皆可，鞋子、贴身衣物除外）每日限量100份！先到先得！'
                    },







                    {
                        title:'体育助力垃圾分类——聚力公益，让生活更美好',
                        url:'https://mp.weixin.qq.com/s/2I8Y7QRbXY8ZxFQcHhksYQ',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/tab2_1.jpg',
                        content:'10月10日上午，由宁波市体育局、宁波市综合行政执法局、宁波市供销合作社联合社主办，宁波市体育彩票管理中心、宁波供销再生资源科技有限公司承办的体育助力垃圾分类——体彩搭把手一体机发布仪式，在宁波雅戈尔体育馆举行。'
                    },
                    {
                        title:'国庆重磅活动 | 每日投递、回归有奖，好礼不停歇...还可瓜分万元奖金',
                        url:'https://mp.weixin.qq.com/s/uPCZvSdZB60CcojH5ExY2A',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/tab2_2.jpg',
                        content:'2020年10月1日，正是《宁波市生活垃圾分类管理条例》颁布的一周年\n' +
                        '想必小伙伴们，在这一年垃圾分类的能力蹭蹭提高了不少\n' +
                        '正值佳节，搭把手又要搞事情，送好礼啦！\n' +
                        '\n' +
                        '10/1-8 每日投递都有奖励\n' +
                        '邀请新人好礼多多\n' +
                        '更有老用户回归，投递立即翻倍\n' +
                        '10000元奖金等你来瓜分~\n'
                    },
                    {
                        title:'十一活动预告 | 城市记忆，由此铺开',
                        url:'https://mp.weixin.qq.com/s/fnw6L49bQsCiTkxQ3L0ViA',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/tab2_3.jpg',
                        content:'2020.10.1 宁波城市记忆馆开业城市记忆讲堂 | 宁波老工厂'
                    },
                    {
                        title:'不瓶凡 | 可口可乐联合搭把手，走进西湖边上的环保展',
                        url:'https://mp.weixin.qq.com/s/UziE5L0Igu44fKl4HqPXcw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/tab2_4.png',
                        content:'9月17日——9月20日，杭州西湖边的“未来生活节”上，搭把手智能饮料瓶回收机现身可口可乐的环保展：“不瓶凡展”。\n' +
                        '    本次，可口可乐与搭把手联合，共同推出可口可乐&搭把手“智能饮料回收机”。在消费者购买饮料的同时，提醒消费者通过智能回收机进行垃圾分类与回收。用实际行动来实践其环保愿景——“天下无废，共创一个没有废弃物的世界”。\n'
                    },
                    {
                        title:'三江购物25周年，促销活动来啦！百款爆品，会员多买多优惠～',
                        url:'https://mp.weixin.qq.com/s/XgQ-6d4qq4xqBCZEHCNcZw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/tab2_5.png',
                        content:'本地宁波人zui喜欢的三江购物，25周年啦！！！\n' +
                        '促销活动来袭，百款爆品，会员多买多优惠～\n' +
                        '8月27日至9月9日，三江购物25周年庆。会员顾客积分兑换好礼，凭卡内积分到线下门店服务台，线上云菜系统均可兑换相应礼品！\n'
                    },
                    {
                        title:'中国环博会——搭把手“成绩单”来了！',
                        url:'https://mp.weixin.qq.com/s/ZkkOhC1VaYm3OKQfUwCLzw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-08_18/tab1.jpg',
                        content:'2020年8月13日-15日，为期三天的第二十一届中国环博会，在上海新国际博览中心完美落下帷幕。由搭把手自主研发的新一代“黑科技”产品——巨无霸，首次对外展出，庞大的身躯、包含多项智能的功能，在展会期间受到许多业内同行及客户的广泛关注与咨询。'
                    },
                    {
                        title:'久邻钜惠，限时限量！isaapo洗衣液2L仅4.9元包邮',
                        url:'https://mp.weixin.qq.com/s/xlvkB-XH0ESmNiScaBG9xg',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-08_18/tab2.jpg',
                        content:'isaapo洗衣液除菌净螨、温和亲肤，清洁宝贝们的贴身衣物也完全没有问题，持久coco清香，让宝宝们对自己的衣服爱不释手！'
                    },
                    {
                        title:'8月亚洲旗舰环保展——中国环博会，搭把手诚邀您莅临参观',
                        url:'https://mp.weixin.qq.com/s/BgR2lx11ZVvsTjOOAxreCA',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2020-08-10/tab3.jpg',
                        content:'疫情过后，环保产业亟需抓住一个新机遇，追回过去浪费的几个月，重整未来的下半年。作为亚洲旗舰环保盛会，第21届中国环博会不负众望，在疫情冲击下仍逆势扩馆，全力促进环保产业商贸交流、品牌推广、资讯分享和复工复产。'
                    },
                    {
                        title:'搭把手公益周开启，空饮料瓶投递可选公益捐赠！',
                        url:'https://mp.weixin.qq.com/s/ujVNkFYSDhcHFgSVr2lUWw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2020-08-10/tab2.jpg',
                        content:'为青少年消防安全教育献爱心，搭把手助力“2020三江纯悦安全守护计划”，启动仪式与7月29日晚圆满完成。即日起，搭把手开启为期7天的公益周活动，继续为公益献爱心。'
                    },
                    {
                        title:'宁聚力量 安全童行 | 搭把手助力2020三江纯悦安全守护计划',
                        url:'https://mp.weixin.qq.com/s/zIPFNSFpnc7F-OtPtLklKg',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2020-08-10/tab1.jpg',
                        content:'炎炎夏日，持续高温。7月29日晚上四十户爱心家庭齐聚宁波三江胜丰店广场为青少年消防安全教育献爱心。由浙江省青少年发展基金会，宁波市消防救援支队主办，三江购物俱乐部股份有限公司、宁波供销再生资源科技有限公司、浙江太古可口可乐饮料有限公司等公益联盟共同发起“2020三江纯悦安全守护计划”公益消防启动仪式。'
                    },
                    {
                        title:'《讲大道—生活》王阿姨&青青推荐！阳光玫瑰葡萄，直播仅69元，限100箱',
                        url:'https://mp.weixin.qq.com/s/YucHJIQKtkqDsCjRobnsTA',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-07_30/tupian6.jpg',
                        content:'7/18日（周六）上午10:00 《讲大道—生活》的王阿姨和青青，将实地前往海珍果园基地，为大家直播阳光玫瑰的“现实生活”，在直播间“广电云”，为大家送上超超超超值福利！！！'
                    },
                    {
                        title:'秒杀价39元/约4.5斤 ！正宗奉化水蜜桃，现摘现发，夏日甜蜜必备~',
                        url:'https://mp.weixin.qq.com/s/uYCapxaBHqXaOqYMt1s2fw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-07_30/tupian5.jpg',
                        content:'阿拉宁波人一年四季果品不断，要说水蜜桃，那必须得是来自奉化的正宗水蜜桃才行~琼浆玉露，瑶池珍品。咬上一口，幸福一整天。'
                    },
                    {
                        title:'【仅39元抢原价58】端午佳品，嘉庆斋高汤粽子，多种口味，江浙沪包邮！',
                        url:'https://mp.weixin.qq.com/s/o0X8a6HIZEq8ms61jVF8tA',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-07_30/tupian3.jpg',
                        content:'端午节即将到来，为了满足大家有个性的食粽欲望，这次为大家推出了嘉庆斋高汤金粽——锦绣江南礼盒，甄选多种口味鲜粽，粽香情浓。'
                    },
                    {
                        title:'山姆会员商店非会员体验日来啦！',
                        url:'https://mp.weixin.qq.com/s/IOxJV9f74ESF1r5ekItmYQ',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-07_30/tupian4.jpg',
                        content:'宁波双店同庆&非会员开放体验日：时间：2020年6月20日-6月21日'
                    },



                    {
                        title:'【仅79元抢原价129】余姚、慈溪正宗荸荠杨梅，现摘现发，顺丰包邮',
                        url:'https://mp.weixin.qq.com/s/g65-7Bx8AuJEsEnI_OayFQ',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab2/huodong1.png',
                        content:'绿阴翳翳连山市，丹实累累照路隅。六月的杨梅红的和云霞一样，把山路都照的亮堂。先别说味道，光是看到了就想摘几颗往嘴里塞。\n' +
                        '\n' +
                        '宋代大诗人苏东坡曾留下：“闽广荔枝，西凉葡萄，未若吴越杨梅"的佳句，来赞誉这世属吴越之地的杨梅。\n'
                    },{
                       title:'@所有人，搭把手带你去免费体验宁波北山姆会员商店啦！',
                       url:'https://mp.weixin.qq.com/s/FGzf1DkNYR9ZQxUDFOCSxA',
                       imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab2/act1.jpg',
                       content:'即日起至5月31日，搭把手携手宁波北山姆会员商店，派发免费体验券啦！！！'
                    },{
                        title:'鄞州区垃圾分类专项活动—晒出分类照，答题赢红包',
                        url:'https://mp.weixin.qq.com/s/mJuLaXGtYcuEFhuQkDyqRw',
                        imgUrl: 'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab2/act2.jpg',
                        content: '5月11日至6月7日，正确分类厨余垃圾，拍照上传，每周瓜分千元红包!更有分类知识答题，累计答对可获得随机大红包，聪明的你，抓紧来啊~'
                    },{
                        title:'【搭把手会员福利到】宁海白枇杷49元/3斤，产地直发，江浙沪顺丰包邮！',
                        url:'https://mp.weixin.qq.com/s/xXfVZWMqBGa2jeYIG6xtEA',
                        imgUrl: 'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab2/act3.jpg',
                        content:'（5月15起，所有订单按付款先后顺序陆续安排发货。因白枇杷为生鲜水果产品，运输过程中水分略有蒸发，重量误差为±10%左右）'
                    },{
                        title:'鄞州区垃圾分类专项活动结束啦！',
                        url:'https://mp.weixin.qq.com/s/YoNxmHW3QVh_2KvcwdDCng',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab2/act4.jpg',
                        content:'鄞州区垃圾分类专项活动结束啦'
                    }

                ],
                tabs3: [
                    // {
                    //     title:'',
                    //     url:'',
                    //     imgUrl:'',
                    //     content:''
                    // },
                    {
                        title:'宁波东海实验学校实践活动——东海蓝，在我心，资源分拣我能行',
                        url:'https://mp.weixin.qq.com/s/0YOS-4weYPnQH4HQ-78_sQ',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-08_18/tab3.jpg',
                        content:'2020年8月16日上午，来自宁波东海实验学校205中队的同学们，来到搭把手姜山分拣中心、智慧产业园开展垃圾分类暑期实践活动。此次搭把手与宁波东海实验学校的联合活动，通过寓教于乐的方式，让每一位同学都大大提升了垃圾分类的意识。东海蓝，在小朋友的心中，相信他们在经历一番学习后，都将是资源分拣源头工作的“小能手”。'
                    },
                    {
                        title:'走进象山 | 搭把手垃圾分类净滩活动、校园课堂积极开展',
                        url:'https://mp.weixin.qq.com/s/-I4mReX3a7iHq_bMb1hvFQ',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab3/ke1.jpg',
                        content:'近日，搭把手走进象山，组织开展净滩和校园课堂活动，倡导生态环保，通过实际行动，践行绿色发展品牌文化，推广宣传垃圾分类。'
                    }
                ],
                tabs4: [

                    // {
                    //     title:'',
                    //     url:'',
                    //     imgUrl:'',
                    //     content:''
                    // },

                    {
                        title:'搭把手饮料瓶回收机“住进”宁波雅戈尔动物园啦！',
                        url:'https://mp.weixin.qq.com/s/Ux8sr3nCbnwDWKBBIzC22Q',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/tab3_1.jpg',
                        content:'8月27日起，搭把手的饮料瓶回收机，也“住进”雅戈尔动物园了，本次，搭把手与雅戈尔动物园强强联合，游客们游览过程中产生的饮料空瓶，通过搭把手小程序，出示二维码，机器进行扫码开箱，就可以轻松投递，爱护园区环境。'
                    },
                    {
                        title:'定了！9月19-20日宁波城市记忆馆，试营业！',
                        url:'https://mp.weixin.qq.com/s/DNXukuk1-ptusIgrjktdbw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-10-12/find/tab3_2.jpg',
                        content:'宁波城市记忆馆是一家传播宁波本地城市文化和旧物美学为方向的文化机构以宁波老城近现代旧物为媒介综合展览馆为依托，深挖宁波本地文化不断探索“无用”旧物的艺术化创新之路'
                    },

                    {
                        title:'关爱职工，平安度夏，工会送清凉！',
                        url:'https://mp.weixin.qq.com/s/DLjkor3u9Rt0xXHX502PUg',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2020-08-10/tab4.jpg',
                        content:'7月30日下午，宁波供销再生资源有限公司迎来了一股清凉。为进一步做好暑期安全生产，防暑降温工作，确保广大职工的身心健康，及时把党支部、公司及工会的关怀送至广大一线员工，经工会委员会决定，开展情系一线的“平安度夏送清凉”活动。\n'
                    },
                    {
                        title:'宁波“创二代”走进搭把手！',
                        url:'https://mp.weixin.qq.com/s/6XMyINPvc8XlJ39Jn1nxzw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2020-08-10/tab5.jpg',
                        content:'7月30日，宁波市“创二代”联谊会走进理事单位活动到访搭把手姜山再生资源分拣中心，并进行座谈交流，深入了解“搭把手”回收平台。'
                    },
                    {
                        title:'情系山区 | 搭把手送书助学江西山区小学',
                        url:'https://mp.weixin.qq.com/s/q0m4wnoBvkzmTgOMGaBviA',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-07_30/tupian7.jpg',
                        content:'爱心捐书，传递的是爱心。搭把手一直以来，将有用的书籍分拣保留下来，就是希望能有一天，让这些书籍被再利用，再创造更多的价值，比起废纸再生，让知识重新被点燃，才是我们所向往的。'
                    },
                    {
                        title:'重磅回馈 | 搭把手会员量突破50万，价值999元挂烫机等待有缘人！',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab4/zixun7.png',
                        url:'https://mp.weixin.qq.com/s/jig2LftI11kBNp2xwEiECw',
                        content:'全体乡亲父老们，喜讯！搭把手会员量已经突破50万啦！！!'
                    },
                    {
                        title:'搭把手智能饮料瓶回收机“安家”宁波栎社国际机场',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab4/zixun6.jpg',
                        url:'https://mp.weixin.qq.com/s/lGBvCkqUF1JrdBITQBP2Dw',
                        content:'经常出差的朋友们\n' +
                        '有惊喜哦\n' +
                        '\n' +
                        '搭把手智能饮料瓶回收机\n' +
                        '在宁波栎社国际机场安家啦！\n'
                    },
                    {
                        title:'搭把手塑料瓶回收，超过1000万只！！！',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab4/zixun5.jpg',
                        url:'https://mp.weixin.qq.com/s/o-MwHsaRTaH5LFM71ufZgA',
                        content:'塑料是重要的基础材料，在社会生产和居民生活中应用广泛。不规范生产、使用、处置塑料会造成资源能源浪费，带来生态环境污染，影响群众健康安全。'
                    },
                    {
                        title:'复工复产后，搭把手各区分拣中心开启加速模式',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab4/zixun4.jpg',
                        url:'https://mp.weixin.qq.com/s/GsRn77MEZ7HUF2XA9x9wSA',
                        content:'随着企业复工复产进程的加速推进，垃圾日产量也随之增多。日前，宁波各区垃圾分拣中心开启加速模式，助力宁波市垃圾分类。'
                    },
                    {
                        title:'垃圾分类“搭把手”—CEO带您探究新型回收模式的一天。',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab4/zixun3.jpg',
                        url:'https://mp.weixin.qq.com/s/ZAxEPICHG3EWOWk2XIhUBQ',
                        content:'宁波三套知识产权新视界栏目推出了专题节目——垃圾分类“搭把手”。本次节目邀请宁波供销再生资源科技有限公司CEO闵亚军作为嘉宾，与主持人及其他嘉宾，一同探讨关于“垃圾”的话题，并介绍了搭把手线下如何运作可回收物处理。'
                    },
                    {
                        title:'全市“搭把手”智能回收箱86%恢复正常收运',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab4/zixun2.jpg',
                        url:'https://mp.weixin.qq.com/s/6kWa8MbWpTS7O7JTZsssSg ',
                        content:'2月26日下午3点，“搭把手”清运司机胡建君来到鄞州区三池路的和韵家园小区，只见胡师傅停下车子、摇下车窗、探出脑袋，社区工作人员拿出额温枪给胡师傅测量体温。“36.3℃”，社区工作人员说，同时向胡师傅摆了摆手，胡师傅重新启动车子驶进了小区'
                    },
                    {
                        title:'疫情防控战，搭把手在行动！',
                        url:'https://mp.weixin.qq.com/s/v096CMvmmd1N9ctWrxzriw',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery20202-06-10/tab4/zixun1.jpg',
                        content:'1月23日，浙江省启动突发公共卫生事件一级应急响应，搭把手回收重视疫情，积极应对，贯彻落实各项防疫消毒措施。\n' +
                        '搭把手回收姜山、大榭、北仑、镇海、古林各处分拣中心积极采取行动，清运分拣工作人员严格遵守制度，佩戴口罩作业。清运车辆、设备、分拣中心各区域都做了细化具体的消毒防护工作，除此之外，各类可回收物堆放区域、办公区也逐一消毒防护\n'
                    }
                ],
                tabs5: [
                    // {
                    //     title:'',
                    //     url:'',
                    //     imgUrl:'',
                    //     content:''
                    // }
                    {
                        title:'回收宝典 | 搭把手智能回收设备操作答疑（已收藏√）',
                        url:'https://mp.weixin.qq.com/s/Hlh2Bb82wvtpUjlJDw54jQ',
                        imgUrl:'https://dbshs.oss-cn-shanghai.aliyuncs.com/active/discovery2021-01-05/tab4_1.jpg',
                        content:'提现的资源币还未到账？怎么无法提现到微信、支付宝？饮料瓶怎么塞不进去？兴致冲冲到楼下投递，怎么就满仓了？目前为止，搭把手已经有2100+个点位，同时，也收到了不少用户反馈的问题，一直以来，搭把手努力在给广大用户提供更好的使用体验。看你骨骼清奇，趁着节日的祝福，我这里有一本《回收宝典》，不要钱，免费送！他日练成“回收大师”后，记得多多帮忙安利。'
                    }
                ],

            }
        },
        methods: {
            tabChange(index, title) {
                this.discoveryList = [index, title]
            },
            openTabNews(url) {
                window.open(url)
            },
            qh(index) {
                this.index = index;
                if (this.index === index) {
                    this.show = index + 1
                }
            }
        }
    }
</script>

<style>
    .container .van-swipe {
        background-color: rgba(255, 255, 255, 0.82);

    }

    .container .van-tabs {
        overflow: hidden;
    }

    .container .van-tabs__wrap {
        padding-left: 10px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.13);
        background-color: rgba(255, 255, 255, 0.82);
    }

    .container .van-hairline--top-bottom::after,
    .container .van-hairline-unset--top-bottom::after {
        border-width: 0;
    }

    .container .van-tab {
        font-size: 12px;
    }

    .container .van-tab--active {
        color: #000000;
        font-size: 14px;
    }

    .container .van-tabs__line {
        width: 30px !important;
        height: 4px;
        border-radius: 2px;
        background-color: #0365FF;
    }
</style>
<style scoped>
    .container {
        min-height: 100vh;
    }

    .title {
        height: 60px;
        width: 100%;
        background-color: white;
        line-height: 60px;
        position: relative;
        display: flex;
        justify-content: space-between;
    }

    .firstitle {
        position: absolute;
        top: -2px;
    }

    .name {
        font-size: 18px;
        margin-left: 20px;
    }

    .rightCon {
        display: flex;
        font-size: 13px;
        position: relative;
        cursor: pointer;
    }

    .fond {
        padding: 0 10px 10px 18px;
        background-color: white;
        font-size: 14px;
        font-weight: 600;
    }

    .swipeStyle {
        width: 180px;
        height: 100px;
        margin-left: 18px;
        border-radius: 5px;
        overflow: hidden;
    }

    .container {
        background-color: #F8F8F8;
    }

    .list {
        padding: 20px 20px;
    }

    .list .item {
        background-color: rgba(255, 255, 255, 0.82);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.13);
        border-radius: 6px;
        margin-bottom: 14px;
    }

    .list .item img {
        width: 100%;
    }

    .list .item .con {
        padding: 14px;
    }

    .list .item .con .msg {
        display: inline-flex;
        align-items: center;
        font-size: 10px;
        color: #0365FF;
        height: 20px;
        padding: 0 6px 0 8px;
        margin-bottom: 10px;
        line-height: 20px;
        border-radius: 4px;
        border: 1px solid rgba(3, 101, 255, 0.5);
        background-color: rgba(3, 101, 255, 0.1);
    }

    .list .item .con .msg img.img-msg {
        width: 10px;
        height: 9px;
        margin-right: 5px;
    }

    .list .item .con .msg img.img-arrow {
        width: 4px;
        height: 6px;
        margin-left: 5px;
    }

    .list .item .con h3 {
        font-size: 14px;
        margin-bottom: 5px;
    }

    .list .item .con p {
        font-size: 12px;
        color: #727272;
        line-height: 17px;
    }

    .icon-tips {
        display: flex;
        padding: 15px 0 5px 0;
    }

    .imgstyle {
        width: 16px !important;
        height: 16px !important;
    }

    .share {
        flex: 6;
    }

    .view {
        flex: 1.5;
    }

    .collection {
        flex: 1.5;
        text-align: right;
    }

    .supStyle {
        color: #818181;
        font-size: 12px;
    }

    .huadong {
        width: 100%;
    }

    .bt {
        width: 100%;
        height: 50px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.13);
    }

    nav {
        padding: 0 5px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        overflow: auto;
    }

    nav .navSpan {
        font-size: 13px;
        display: inline-block;
        margin-top: 22px;
        width: 80px;
        text-align: center;
        margin-left: 10px;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        color: #666666;
    }

    .active {
        /*color: white;*/
        font-size: 15px;
        font-weight: 600;
        /*border-bottom: 2px solid #0365FF;*/
    }

    .active2 {
        background-color: #0365FF;
    }
    .liusanhang{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
</style>